import React from 'react';
import { Navigate } from 'react-router-dom';

// Signup flow is now handled entirely by Google OAuth on /login.
// This shim keeps existing /signup links and bookmarks working.
const SignupPage = () => <Navigate to="/login" replace />;

export default SignupPage;
